export default __webpack_public_path__ + "static/media/database.781748e3.jpeg";